import T from 'types'
import { get, isUndefined } from 'lodash'
import SurveyTracker from '../interface'
import AbstractTracker from '../AbstractTracker'
import ONBOARDING_STEPS from 'page/common/steps'
import { onboardingSpecialty, specialtyToFamily } from 'utils/trackers/utils'

const taboolaTrackingMap = {
  consultation: {
    lead: {
      sexual: 'lead_sexologie',
    },
    booking: {
      sexual: 'consult_sexologie'
    },
    checkout: {
      sexual: 'start_checkout'
    }
  },
}

class TaboolaTracker extends AbstractTracker implements SurveyTracker {
  private static readonly ONBOARDING_PREFIX = 'ONB'

  config: string | undefined

  constructor() {
    super()
    this.config = process.env.REACT_APP_TABOOLA_ACCOUNT_ID
  }

  private enabled(): boolean {
    return (!!this.config) && (typeof window._tfa !== 'undefined')
  }

  public trackLead(specialty: string) {
    const family = specialtyToFamily(specialty)
    this.track(get(taboolaTrackingMap.consultation.lead, family))
  }

  public trackDidPayConsultation(
    transactionId: number | any,
    transactionPrice: string,
    consultationType: string,
    medium: string,
    specialty: string,
  ) {
    const family = specialtyToFamily(specialty)
    this.track(get(taboolaTrackingMap.consultation.booking, family))
    this.trackOnboardingStepView(ONBOARDING_STEPS.PAYMENT, 'consultation-payee')
  }

  public trackDidEnterOnboarding(trackAddToCart: boolean): void {
    this.trackOnboardingStepView(-1)
    if (trackAddToCart) {
      this.trackAddToCart()
    }
  }

  public trackAddToCart() {
    const specialty = onboardingSpecialty()
    const family = specialtyToFamily(specialty)
    this.track(get(taboolaTrackingMap.consultation.checkout, family))
  }

  public trackOnboardingStepView(step: number, subStep?: string) {
    const trackingStep = step + 1
    const pageTitle = `[${TaboolaTracker.ONBOARDING_PREFIX}-${trackingStep}] ${subStep}`
    const pagePath = ['/questionnaire.html', trackingStep, subStep]
      .filter(el => el != null)
      .join('/')
    this.trackPageViewV1(pageTitle, pagePath)
  }

  public trackPageViewV1(pageTitle: string, pagePath: string) {
    this.track('page_view')
  }

  private track = (name: string| undefined): void => {
    if (this.enabled() && !isUndefined(name)) {
        window._tfa.push({ notify: 'event', name, id: this.config })
    }
  }

}

export default TaboolaTracker
